import React from "react";
import styles from "./FightingGamepad.module.css";
import type { VirtualGamepadProps } from "../../constants/gamepad";
import { useGamepadLogic } from "../../hooks/useGamepadLogic";
import {
  ActionButtonGroup,
  DPadButtonGroup,
  Joystick,
  TopButtonContainer,
} from "../shared";
import LBIcon1x from "../../assets/icons/LB@1x.webp";
import LBIcon2x from "../../assets/icons/LB@2x.webp";
import LBIcon3x from "../../assets/icons/LB@3x.webp";
import RBIcon1x from "../../assets/icons/RB@1x.webp";
import RBIcon2x from "../../assets/icons/RB@2x.webp";
import RBIcon3x from "../../assets/icons/RB@3x.webp";
import { Button } from "../shared/Button";
import type { StreamStatus } from "../..";

interface FightingGamepadProps {
  onStateChange?: VirtualGamepadProps["onStateChange"];
  sendMessage?: VirtualGamepadProps["sendMessage"];
  onToggleMenu?: () => void;
  isActive?: boolean;
  streamStatus?: StreamStatus;
}

export const FightingGamepad: React.FC<FightingGamepadProps> = ({
  onStateChange,
  sendMessage,
  onToggleMenu,
  isActive = false,
  streamStatus,
}) => {
  const {
    isLeftJoystickActive,
    leftJoystickOuterRef,
    handleButtonTouchStart,
    handleButtonTouchEnd,
    handleButtonMouseDown,
    handleButtonMouseUp,
    handleLeftJoystickTouchStart,
    handleLeftJoystickTouchMove,
    handleLeftJoystickTouchEnd,
    handleLeftJoystickMouseDown,
    leftJoystickTransform,
  } = useGamepadLogic({
    onStateChange,
    sendMessage,
    onToggleMenu,
    isActive,
    streamStatus,
  });

  if (!isActive) return null;

  return (
    <div className={styles.container}>
      <div className={styles.gamepadContainer}>
        <TopButtonContainer
          onTouchStart={handleButtonTouchStart}
          onTouchEnd={handleButtonTouchEnd}
          onMouseDown={handleButtonMouseDown}
          onMouseUp={handleButtonMouseUp}
        />
        <div className={styles.left}>
          <DPadButtonGroup
            onTouchStart={handleButtonTouchStart}
            onTouchEnd={handleButtonTouchEnd}
            onMouseDown={handleButtonMouseDown}
            onMouseUp={handleButtonMouseUp}
          />
          <Joystick
            isActive={isLeftJoystickActive}
            outerRef={leftJoystickOuterRef}
            onTouchStart={handleLeftJoystickTouchStart}
            onTouchMove={handleLeftJoystickTouchMove}
            onTouchEnd={handleLeftJoystickTouchEnd}
            onMouseDown={handleLeftJoystickMouseDown}
            transform={leftJoystickTransform}
            className={styles.leftJoystick}
          />
        </div>
        <div className={styles.bottomRight}>
          <div className={styles.triggerButtonsContainer}>
            <Button
              buttonKey="l1"
              iconConfig={{
                src1x: LBIcon1x,
                src2x: LBIcon2x,
                src3x: LBIcon3x,
              }}
              onTouchStart={(e, buttonKey) =>
                handleButtonTouchStart(e, buttonKey!)
              }
              onTouchEnd={(e, buttonKey) => handleButtonTouchEnd(e, buttonKey!)}
              onMouseDown={(e, buttonKey) =>
                handleButtonMouseDown(e, buttonKey!)
              }
              onMouseUp={(e, buttonKey) => handleButtonMouseUp(e, buttonKey!)}
            />
            <Button
              buttonKey="r1"
              iconConfig={{
                src1x: RBIcon1x,
                src2x: RBIcon2x,
                src3x: RBIcon3x,
              }}
              onTouchStart={(e, buttonKey) =>
                handleButtonTouchStart(e, buttonKey!)
              }
              onTouchEnd={(e, buttonKey) => handleButtonTouchEnd(e, buttonKey!)}
              onMouseDown={(e, buttonKey) =>
                handleButtonMouseDown(e, buttonKey!)
              }
              onMouseUp={(e, buttonKey) => handleButtonMouseUp(e, buttonKey!)}
            />
          </div>
          <ActionButtonGroup
            onTouchStart={handleButtonTouchStart}
            onTouchEnd={handleButtonTouchEnd}
            onMouseDown={handleButtonMouseDown}
            onMouseUp={handleButtonMouseUp}
          />
        </div>
      </div>
    </div>
  );
};
